export default __webpack_public_path__ + "static/media/mens_diamond_band.02814898.png";